import { Component, OnInit, EventEmitter, Output, HostListener } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientService } from './clients.service';
import { faEllipsisV, faEarthAsia, faSearch, faBars, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError, delay } from 'rxjs/operators';
import { UserGroupService } from 'src/app/core/services/user-group/user-group.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
@Component({
    selector: 'app-clients',
    templateUrl: './clients.component.html',
    styleUrls: ['./clients.component.scss'],
})
export class ClientsComponent implements OnInit {
    @Output() dataLoaded: EventEmitter<boolean> = new EventEmitter();
    clientName: string = ''; // Bind to clientName input
    description: string = ''; // Bind to description input
    clients: Array<any> = []; // Replace with the actual type if available
    isLoading: boolean = true;
    isFirstTime: boolean = true;
    showMenu = false;
    clientid: number = 0;
    isValidClientForm: boolean = true;
    faEllipsisV = faEllipsisV;
    query: string = ''; // Search query
    limit: number = 10; // Items per page
    offset: number = 0; // Offset (for pagination)
    totalItems: number = 0; // Total number of items (to calculate total pages)
    currentPage: number = 1;
    searchText: string = '';
    searchClientName: string = '';
    clientDataToPass: any;

    // itemsPerPage: number = 10;

    constructor(
        private modalService: NgbModal,
        private toastrService: ToastrService,
        private clientService: ClientService,
        private usergroup: UserGroupService,
        private router: Router,
        private commonservice: CommonServiceService,
    ) {}

    ngOnInit(): void {
        this.loadClients();
        this.getRoles();
        // this.openConfirmationModal(confirmationModal);
    }
    // @HostListener('document:click', ['$event'])
    //     onDocumentClick(event: MouseEvent): void {
    //         // Close the popup if clicked outside
    //         this.activePopupIndex = null;
    //     }

    //  @HostListener('document:click', ['$event'])
    //     onDocumentClick(event: MouseEvent) {
    //         // Check if the click is outside the dropdown
    //         if (!this.elementRef.nativeElement.contains(event.target)) {
    //             if (this.dropdownOpen) {
    //                 this.emitChanges();
    //             }
    //             this.dropdownOpen = false;
    //         }
    //     }
    // Method to open the login modal
    openClientModal(content: any): void {
        this.isValidClientForm = true;
        this.isValidClientName = false;
        this.isValidClientMsg = '';
        this.clientName = '';
        this.description = '';
        this.clientid = 0;
        this.modalService.open(content, { size: 'sm', windowClass: 'custom-modal-client', backdrop: 'static', keyboard: false });
    }
    isValidClientName: boolean = false;
    isValidClientMsg: string = '';

    //Method to verify client name exist or not
    verifyClientName() {
        if (this.clientid === 0) {
            this.isValidClientForm = true;
            this.isValidClientName = false;
            this.isValidClientMsg = '';
            this.isLoading = true;
            if (this.clientName.trim() !== '') {
                console.log('this.clientName');
                console.log(this.clientName);
                this.clientService.getVerifyisClientExist(this.clientName).subscribe({
                    next: (response) => {
                        this.isLoading = false;
                        this.isValidClientName = response.data;
                        this.isValidClientMsg = response.message;
                        const userGroupnamePattern = /[a-zA-Z0-9]/;
                        if (!this.isValidClientName && userGroupnamePattern.test(this.clientName)) {
                            this.isValidClientForm = false;
                        }
                        console.log('Client created:', response);
                        //     this.loadClients(); // Reload the clients after creation
                    },
                    error: (err) => {
                        console.error('Error creating client:', err);
                    },
                });
            } else {
                this.isLoading = false; // Stop spinner if name is empty
            }
        }
    }

    // Method to open confirmation modal
    openConfirmationModal(content: any): void {
        this.modalService.open(content, { size: 'sm', centered: true, windowClass: 'custom-modal-class', backdrop: 'static', keyboard: false });
    }

    // Handle form submission
    onSubmit(clientForm: any, createModal: any, confirmationModal: any): void {
        if (clientForm.valid) {
            const clientData = { id: this.clientid, clientTitle: this.clientName, name: this.clientName, description: this.description };
            if (this.clientid === 0) {
                this.clientService.createClient(clientData).subscribe({
                    next: (response) => {
                        console.log('Client created:', response);
                        this.toastrService.success(response.message);
                        this.selectedClient = this.clientName;
                        this.clientDataToPass = response.data;
                        setTimeout(() => {
                            this.openConfirmationModal(confirmationModal);
                        }, 100);
                        createModal.dismiss('Form submitted');
                        // this.loadClients(); // Reload the clients after creation
                    },
                    error: (err) => {
                        this.toastrService.error(err.error.message);
                        console.error('Error creating client:', err);
                    },
                });
            } else {
                this.newClientData.name = this.clientName;
                this.newClientData.clients_details = this.description;
                const strNewJson = JSON.stringify(this.newClientData);
                const strOldJson = JSON.stringify(this.oldClientData);
                if (strNewJson === strOldJson) {
                    this.modalService.dismissAll();
                    return;
                }

                this.clientService.updateClient(clientData).subscribe({
                    next: (response) => {
                        console.log('Client created:', response);
                        this.toastrService.success(response.message);
                        createModal.dismiss('Form submitted');
                        this.loadClients(); // Reload the clients after creation
                    },
                    error: (err) => {
                        this.toastrService.error(err.error.developerMessage);
                        console.error('Error creating client:', err);
                    },
                });
            }
        }
    }

    // Action when user confirms to add a new user group
    confirmAddUserGroup(): void {
        console.log('User confirmed to add new user group');
        // Call service to save client data and add user group
        // this.clientService.saveClientData({ clientName: this.clientName, description: this.description });
        this.modalService.dismissAll(); // Close all modals
        this.openUserGroupCreationForm();
    }

    // Action when user cancels the action
    cancelAddUserGroup(): void {
        console.log('User canceled adding a new user group');
        this.modalService.dismissAll(); // Close all modals
        this.currentPage = 1;
        this.offset = 0;
        this.searchClientName = '';
        this.loadClients();
    }
    noData: boolean = false; // For "No data found" message

    // Fetch all clients
    loadClients(): void {
        this.isLoading = true; // Start loading
        this.noData = false; // Reset "no data" flag

        const clientList = {
            query: this.searchClientName,
            limit: this.limit,
            offset: this.offset,
            order: 'DESC',
            sortBy: 'clientId',
        };

        this.clientService.getClients(clientList).subscribe({
            next: (response) => {
                try {
                    if (response) {
                        // Replace null values with default values using nullish coalescing (??)
                        this.clients = response.clients ?? []; // Default to empty array if 'clients' is null or undefined
                        this.totalItems = response.totalCount ?? 0; // Default to 0 if 'totalCount' is null or undefined
                        this.currentPage = Math.floor(this.offset / this.limit) + 1;

                        // Replace null values for other fields with a default value
                        this.clients.forEach((client) => {
                            client.clients_details = client.clients_details ?? ''; // Replace null with 'N/A'
                            client.clients_title = client.clients_title ?? ''; // Replace null with 'No Title'
                            client.name = client.name ?? ''; // Replace null with 'Unknown Client'
                        });

                        // If no data, show "No data found" message
                        this.noData = this.clients.length === 0;
                    } else {
                        this.clients = [];
                        this.noData = true; // Show "No data found" if the response is null
                    }
                } catch (error) {
                    console.error('Error processing client data:', error);
                    this.clients = [];
                    this.noData = true; // Show "No data found" on processing error
                }
            },
            error: (err) => {
                console.error('Error fetching clients:', err);
                this.noData = true; // Show "No data found" on error
            },
            complete: () => {
                this.isFirstTime = false;
                this.isLoading = false; // Stop loading
            },
        });
    }

    onSearch(): void {
        this.limit = 10; // Items per page
        this.offset = 0; // Offset (for pagination)

        this.loadClients(); // Fetch clients based on search query
    }

    oldClientData: any;
    newClientData: any;
    editClient(client: any, content: any) {
        this.oldClientData = { ...client };
        this.newClientData = { ...client };
        this.clientid = client.id;
        this.isValidClientForm = false;
        this.clientName = client.name;
        this.description = client.clients_details;
        this.modalService.open(content, { size: 'sm', windowClass: 'custom-modal-client', backdrop: 'static', keyboard: false });
        this.activePopupIndex = null;
    }

    // onSearchClick() {
    //     this.limit = 10; // Items per page
    //     this.offset = 0; // Offset (for pagination)
    //     this.totalItems = 0; // Total number of items (to calculate total pages)
    //     this.currentPage = 1;
    //     this.query = this.searchClientName;
    //     this.loadClients();
    // }

    // onSearchClick(): void {
    //     this.isLoading = true;
    //     this.noData = false;

    //     // Simulate API call to fetch clients
    //     this.fetchClients(this.searchClientName).subscribe({
    //         next: (data) => {
    //             this.isLoading = false;
    //             if (data && data.length > 0) {
    //                 this.clients = data;
    //                 this.noData = false;
    //             } else {
    //                 this.clients = [];
    //                 this.noData = true;
    //             }
    //         },
    //         error: () => {
    //             this.isLoading = false;
    //             this.noData = true;
    //         },
    //     });
    // }

    fetchClients(searchName: string): Observable<Array<any>> {
        // Replace this mock implementation with your actual API call
        return of([]).pipe(delay(1000)); // Simulating no data after 1 second
    }

    activePopupIndex: number | null = null;
    activeAccessList: number | null = null;

    togglePopup(index: number, event: Event): void {
        event.stopPropagation();
        if (this.activePopupIndex === index) {
            // Close the "Actions" popup
            this.activePopupIndex = null;
        } else {
            // Open the "Actions" popup and close the "Access" popup
            this.activePopupIndex = index;
            this.activeAccessList = null;
        }
    }
    // Close all popups when clicking outside
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent): void {
        this.activePopupIndex = null;
        this.activeAccessList = null;
    }

    closePopup(): void {
        this.activePopupIndex = null; // Close popup
    }

    // Handle the menu toggle for edit options
    onButtonClick(event: Event) {
        this.showMenu = !this.showMenu;
        event.stopPropagation(); // Prevent clicking outside from closing the menu
    }

    // Handle the delete action
    deleteItem() {
        // Perform your delete operation here
        console.log('Delete clicked');
        this.showMenu = false; // Hide menu after action
    }
    pageNumber = {
        page: 1,
    };
    totalPages: any;
    itemsPerPage = 10; // Items per page
    // Get start and end item indices for the current page
    get startItem(): number {
        return (this.currentPage - 1) * this.itemsPerPage + 1;
    }

    onPageChanged(event: any) {
        this.pageNumber = event;
        this.offset = (this.pageNumber.page - 1) * this.itemsPerPage;
        this.limit = this.pageNumber.page === this.totalPages ? this.totalItems - this.offset : this.itemsPerPage;
        this.loadClients();
    }

    get endItem(): number {
        const endItem = this.currentPage * this.itemsPerPage;
        return endItem > this.totalItems ? this.totalItems : endItem;
    }

    // Navigate to the previous page
    prevPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
        }
    }

    // Navigate to the next page
    nextPage(): void {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }
    }
    clientSearchList() {
        if (this.searchClientName != '') this.SearchList();
    }
    SearchList() {
        this.currentPage = 1;
        this.limit = 10; // Items per page
        this.offset = 0; // Offset (for pagination)

        const clientList = { query: this.searchClientName, limit: this.limit, offset: this.offset, order: 'DESC', sortBy: 'clientId' };

        this.clientService.getClients(clientList).subscribe({
            next: (response) => {
                try {
                    if (response) {
                        // Replace null values with default values using nullish coalescing (??)
                        this.clients = response.clients ?? []; // Default to empty array if 'clients' is null or undefined
                        this.totalItems = response.totalCount ?? 0; // Default to 0 if 'totalCount' is null or undefined
                        this.currentPage = Math.floor(this.offset / this.limit) + 1;

                        // Replace null values for other fields with a default value
                        this.clients.forEach((client) => {
                            client.clients_details = client.clients_details ?? ''; // Replace null with 'N/A'
                            client.clients_title = client.clients_title ?? ''; // Replace null with 'No Title'
                            client.name = client.name ?? ''; // Replace null with 'Unknown Client'
                        });

                        // If no data, show "No data found" message
                        this.noData = this.clients.length === 0;
                    } else {
                        this.clients = [];
                        this.noData = true; // Show "No data found" if the response is null
                    }
                } catch (error) {
                    console.error('Error processing client data:', error);
                    this.clients = [];
                    this.noData = true; // Show "No data found" on processing error
                }
            },
            error: (err) => {
                console.error('Error fetching clients:', err);
                this.noData = true; // Show "No data found" on error
            },
            complete: () => {
                this.isFirstTime = false;
                this.isLoading = false; // Stop loading
            },
        });
    }

    userGroupnameText = '';
    descriptionText = '';
    selectedClient: string = ''; // Selected client
    selectedRole = '';
    selectedIds: any;
    selectedOptions: any;
    disableForm = true;
    showcreateandEditForm = false;
    filteredClients: any;
    options: any;
    onChangeUserGroup(selectedValue: string) {
        const reqBody = {
            userGroupId: null,
            query: null,
            userGroupType: selectedValue,
            limit: null,
            offset: 0,
        };
        this.usergroup.getAccessList(reqBody).subscribe((data) => {
            console.log('the response of usergroup access is', JSON.stringify(data.accessList));
            this.options = data.accessList;
            this.selectedOptions = this.options.filter((option: { isSelected: any }) => option.isSelected);
            this.selectedIds = this.selectedOptions.map((option: { id: any }) => option.id);
        });
        console.log('this.userGroupForm.value', this.userGroupnameText, this.descriptionText, this.selectedClient, selectedValue);
    }
    onToggle(option: any, value: any) {
        const index = this.selectedOptions.indexOf(option);
        if (value.target.checked) {
            option.isSelected = true;
        } else {
            option.isSelected = false;
        }
        console.log('option 1 2 3 4', option, value);
        if (index > -1) {
            // If the option is already selected, remove it
            this.selectedOptions.splice(index, 1);
        } else {
            // Otherwise, add it
            this.selectedOptions.push(option);
        }

        this.selectedIds = this.selectedOptions.map((option: { id: any }) => option.id);
        console.log('this.selectedOptions are', option, JSON.stringify(this.selectedOptions), this.selectedIds);
    }
    searchTerm: string = ''; // For two-way binding with search bar
    usergroupId: any;
    createNewUserGroup() {
        console.log(' this.usergroupId ', this.usergroupId);
        const request = {
            groupId: this.disableForm ? this.usergroupId : null,
            userGroupName: this.userGroupnameText,
            label: this.descriptionText,
            clientName: this.searchTerm,
            userGroupType: this.selectedRole,
            accessIds: this.selectedIds,
        };

        this.selectedClient = this.searchTerm;
        // this.usergroup.createandupdate(request).subscribe((data)=> {
        console.log('the response of usergroup create and update is', request);
        // })
        if (this.userGroupnameText !== '' && this.descriptionText != '' && this.selectedClient != '' && this.selectedRole != '' && this.selectedIds.length != 0) {
            this.usergroup
                .createandupdate(request)
                .pipe(
                    catchError((error) => {
                        if (error.status === 500) {
                            // Handle 500 error specifically
                            console.error('Server error occurred:', error.error.message);
                            this.toastrService.warning(error.error.message);
                        } else {
                            // Handle other errors
                            console.error('An error occurred:', error);
                        }
                        // Return an empty observable so the app doesn't break
                        return of(null);
                    }),
                )
                .subscribe((data: any) => {
                    if (data) {
                        // API response is successful, handle the data
                        this.toastrService.success(data.message);
                        this.showcreateandEditForm = false;
                        // this.callandRefreshusergroup();
                    }
                });
        }
    }
    getSelectedOptions() {
        console.log('selectedOptions are selectedOptions', this.selectedOptions);
        if (this.selectedOptions?.length > 0) {
            // Join the selected options with a comma separator
            return this.selectedOptions.map((option: { name: any }) => option.name);
        } else {
            return 'Select';
        }
    }
    filterClients(): void {
        const term = this.searchTerm.toLowerCase();
        const req = {
            query: term,
            limit: 10,
            offset: 0,
        };
        this.usergroup.getClientList(req).subscribe((data) => {
            this.clients = data.clients;
            console.log('the response of usergroup clientlist is', data);
            this.filteredClients = this.clients.map((client: { name: any }) => client.name).filter((client: string) => client.toLowerCase().includes(term));
        });

        console.log('filteredClients are', this.filteredClients);
    }
    isFormValid(): boolean {
        return (
            this.userGroupnameText?.trim() && // Check if User Group Name is not empty
            this.selectedClient?.trim() && // Check if a Client Name is selected
            this.selectedRole?.trim() && // Check if a User Group Type is selected
            this.options.some((option: { isSelected: any }) => option.isSelected) // Check if at least one Access option is selected
        );
    }
    openUserGroupCreationForm() {
        // this.userGroupnameText = '';
        // this.descriptionText = '';

        // this.selectedRole = '';
        // this.selectedIds = [];
        // this.selectedOptions = [];
        // this.disableForm = false;
        // console.log('the form is opened');
        // this.showcreateandEditForm = true;
        // this.filterClients();

        //route to usergroup and fill the form with client name
        this.router.navigate(['/admin', 'user-group']);

        const data = {
            createnew: true,
            data: this.clientDataToPass,
        };
        //call a subject to know that this is for a client and usergroup creation
        this.commonservice.setCreateUsergroupforClient(data);
    }
    closeCreateandEditForm() {
        this.showcreateandEditForm = false;
    }

    roles: any;
    getRoles() {
        this.usergroup.usergroupType().subscribe((data) => {
            this.roles = data;
            console.log('the result of usergroupType are', data);
        });
    }
    clearSearch() {
        this.limit = 10; // Items per page
        this.offset = 0; // Offset (for pagination)
        this.currentPage = 1;
        this.searchClientName = ''; // Clear the search input
        this.SearchList();
    }

    restrictInput(event: KeyboardEvent): void {
        const allowedCharacters = /^[a-zA-Z0-9-_ ]*$/;
        const inputChar = event.key;

        if (!allowedCharacters.test(inputChar)) {
            event.preventDefault(); // Block the keypress
        }
    }

    onClearLoad() {
        if (this.searchClientName == '') {
            this.SearchList();
        }
    }
}
